export default __webpack_public_path__ + "static/media/koreadailylogosq.0d957034.png";